import { render, staticRenderFns } from "./MigrationSalaries.vue?vue&type=template&id=dfe6303e&scoped=true"
import script from "./MigrationSalaries.vue?vue&type=script&lang=js"
export * from "./MigrationSalaries.vue?vue&type=script&lang=js"
import style0 from "./MigrationSalaries.vue?vue&type=style&index=0&id=dfe6303e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfe6303e",
  null
  
)

export default component.exports